export * from './product-detail-url'
